/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "/**\n * Color tokens\n *\n * These are the values that express the colors of the design system.\n */\n/**\n * Font tokens\n *\n * These are the values that express the atomic units\n * of the design system.\n */\n/**\n * Layout tokens\n *\n * These are the values that express the spatial dimensions of\n * the design system.\n */\n@keyframes fadeUp {\n  from {\n    margin-bottom: -3em;\n    opacity: 0;\n  }\n  to {\n    margin-bottom: 0em;\n    opacity: 1;\n  }\n}\n.Notification {\n  position: relative;\n  left: 0;\n  width: max-content;\n  margin-right: 0;\n  margin-left: auto;\n  margin-bottom: -3em;\n  padding: 15px;\n  font-size: 1rem;\n  animation-name: fadeUp;\n  animation-duration: calc(0.75s / 2);\n  animation-fill-mode: forwards;\n  background: #FFFFFF;\n  border: 1px solid #6666FF;\n  border-radius: 10px;\n  opacity: 0;\n  transition: left 0.75s, opacity 0.75s;\n}\n.Notification + .Notification {\n  margin-top: 15px;\n}\n.Notification.finished {\n  left: 100%;\n  opacity: 0.3;\n  transition: left 0.75s, opacity 0.75s;\n}\n.Notification__Drawer {\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  z-index: 2147483647;\n  width: 30rem;\n  padding: 15px;\n}";
styleInject(css_248z);

/**
 * Notification
 */
var Notification = /** @class */ (function () {
    function Notification(args) {
        var _this = this;
        this.finished = false;
        this.args = { message: '' };
        if (!Notification._drawer) {
            Notification._createDrawer();
        }
        this._drawer = Notification._drawer;
        var el = this.element = document.createElement('div');
        el.className = "Notification";
        el.addEventListener('mouseenter', function () { return clearTimeout(_this._player); });
        el.addEventListener('mouseleave', function () { return !_this.finished && _this._play(); });
        el.addEventListener('click', function () { return _this.finish(); });
        if (typeof args === 'string') {
            el.innerText = args;
            if (!Notification.defer) {
                this.play();
            }
        }
        else {
            if (args.message != null) {
                el.innerText = args.message;
            }
            if (args.className) {
                el.className += " ".concat(args.className);
            }
            if (args.onClick) {
                el.addEventListener('click', function () { return args.onClick(); });
            }
            this.args = args;
            if (Notification.defer !== undefined) {
                if (args.defer !== true) {
                    this.play();
                }
            }
            else if (Notification.defer !== true) {
                this.play();
            }
        }
    }
    Notification.prototype.finish = function () {
        var _this = this;
        this.finished = true;
        clearTimeout(this._player);
        clearInterval(this._flasher);
        this.element.classList.add('finished');
        this._player = setTimeout(function () {
            _this._drawer.removeChild(_this.element);
        }, 500);
    };
    Notification.prototype.play = function () {
        Notification._current = this;
        this._drawer.appendChild(this.element);
        if (this.args.flash === true || Notification.flash) {
            this._flash();
        }
        if (!(!document.hidden && (this.args.push === false || (this.args.push === undefined && Notification.push !== true)))) {
            Notification._showPushNotification(document.title, this.args.message);
        }
        this._play();
    };
    Notification.prototype._play = function () {
        var _this = this;
        this.finished = false;
        clearTimeout(this._player);
        this.element.classList.remove('finished');
        this._player = setTimeout(function () {
            _this.finish();
        }, this.args.duration || Notification.duration);
    };
    Notification.prototype._flash = function () {
        var _this = this;
        clearInterval(this._flasher);
        var title = document.title;
        this._flasher = setInterval(function () {
            if (Notification._current === _this) {
                if (document.title === title) {
                    document.title = _this.args.message;
                }
                else {
                    document.title = title;
                }
            }
            else {
                clearInterval(_this._flasher);
            }
        }, 500);
    };
    Notification.configure = function (config) {
        if (config.mount && config.mount !== Notification.mount) {
            Notification.mount = config.mount;
            Notification._createDrawer();
        }
        Notification.defer = config.defer !== undefined ? config.defer : Notification.defer;
        Notification.duration = config.duration !== undefined ? config.duration : Notification.duration;
        Notification.flash = config.flash !== undefined ? config.flash : Notification.flash;
        Notification.push = config.push !== undefined ? config.push : Notification.push;
        Notification.serviceWorker = config.serviceWorker !== undefined ? config.serviceWorker : Notification.serviceWorker;
    };
    Notification._createDrawer = function () {
        if (Notification._drawer) {
            Notification._drawer.parentNode.removeChild(Notification._drawer);
        }
        var drawer = document.createElement('div');
        drawer.className = 'Notification__Drawer';
        Notification.mount.appendChild(drawer);
        Notification._drawer = drawer;
    };
    Notification._registerServiceWorker = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, navigator.serviceWorker.register(Notification.serviceWorker)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Notification._requestNotificationPermission = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, window.Notification.requestPermission()];
                    case 1: return [2 /*return*/, (_a.sent()) === 'granted'];
                }
            });
        });
    };
    Notification._showPushNotification = function (title, body) {
        return __awaiter(this, void 0, void 0, function () {
            var options, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        options = {
                            title: title,
                            body: body,
                        };
                        if (!!Notification._serviceWorker) return [3 /*break*/, 2];
                        _a = Notification;
                        return [4 /*yield*/, Notification._registerServiceWorker()];
                    case 1:
                        _a._serviceWorker = _b.sent();
                        _b.label = 2;
                    case 2: return [4 /*yield*/, Notification._requestNotificationPermission()];
                    case 3:
                        if (_b.sent()) {
                            navigator.serviceWorker.ready.then(function (registration) {
                                return __awaiter(this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        registration.showNotification(title, options);
                                        return [2 /*return*/];
                                    });
                                });
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Static
     */
    Notification.mount = document.querySelector('body');
    Notification.defer = false;
    Notification.duration = 3000;
    Notification.flash = false;
    Notification.push = false;
    Notification.serviceWorker = './notification.js';
    return Notification;
}());

export { Notification as default };
//# sourceMappingURL=index.es.js.map
